import React from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { CommonProperties } from '../styles';

import Images from '../constants/Images';
import { scale } from '../utils/scale.utils';

const defaultBorder = scale(6);
const defaultSize = scale(60);
const Avatar = ({ size = defaultSize, style, source, noBorder, isMainStackNavigator = false }) => {
  const border = noBorder ? 0 : defaultBorder;
  const imageStyle = {
    width: size,
    height: size,
    borderRadius: size / 2,
    borderWidth: isMainStackNavigator ? 0 : scale(3),
  };
  const containerStyle = {
    width: size + border,
    height: size + border,
    borderRadius: size / 2 + border,
  };

  return (
    <View style={[styles.avatarContainer, containerStyle, style]}>
      <Image
        style={[noBorder ? null : styles.avatar, imageStyle]}
        source={source || Images.defaultUser}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  avatar: {
    borderColor: 'white',
  },
  avatarContainer: {
    backgroundColor: 'white',
    ...CommonProperties.centerAlignment,
  },
});

export default Avatar;
